import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { MeterResponse } from "../Meter.types";

export const meterQueries = {
  detail: (meterId?: number) =>
    queryOptions<MeterResponse>({
      queryKey: ["meter", { meterId }],
      queryFn: meterId ? () => fetchMeter(meterId) : skipToken,
      enabled: typeof meterId !== "undefined",
      refetchInterval: false,
      refetchOnWindowFocus: false
    })
};

export function useMeter(meterId?: number) {
  return useQuery(meterQueries.detail(meterId));
}

async function fetchMeter(meterId: number) {
  const response = await apiWithoutCamelization.get<MeterResponse>(
    urls.apiWithoutCamelization.meter(meterId)
  );
  return response.data;
}
